import styled, { css } from 'styled-components';
import Tippy from '@tippyjs/react';
const variantOptions = {
    default: {
        color: '#c2c2c2',
        border: '1px solid #c2c2c2',
    },
    error: {
        color: '#FF2929',
        border: '1px solid #FF2929',
    }
};
export const StyledTippy = styled(Tippy) `
  ${({ variant }) => variant &&
    variantOptions[variant] &&
    css `
     &.tippy-box {
      color: ${variantOptions[variant].color};
      padding: 10px 6px;
      box-shadow: 0px 15px 20px #0000004D !important;
    }
    &.tippy-box[data-theme~=light-border] {
      border: ${variantOptions[variant].border};
    }
    &.tippy-box[data-theme~=light-border][data-placement^=bottom]>.tippy-arrow:after {
      border-bottom-color: ${variantOptions[variant].color};
    }
    &.tippy-box[data-theme~=light-border][data-placement^=top]>.tippy-arrow:after {
      border-top-color: ${variantOptions[variant].color};
    }
    &.tippy-box[data-theme~=light-border][data-placement^=right]>.tippy-arrow:after {
      border-right-color: ${variantOptions[variant].color};
    }
    &.tippy-box[data-theme~=light-border][data-placement^=left]>.tippy-arrow:after {
      border-left-color: ${variantOptions[variant].color};
    }
    &.tippy-box[data-theme~='info'] {
      background-color: #FFFEB5;
      color: #4b4b4b;
    }
    &.tippy-box[data-theme~='info'][data-placement^='top'] > .tippy-arrow::before {
      border-top-color: #FFFEB5;
    }
    &.tippy-box[data-theme~='info'][data-placement^='bottom'] > .tippy-arrow::before {
      border-bottom-color: #FFFEB5;
    }
    &.tippy-box[data-theme~='info'][data-placement^='left'] > .tippy-arrow::before {
      border-left-color: #FFFEB5;
    }
    &.tippy-box[data-theme~='info'][data-placement^='right'] > .tippy-arrow::before {
      border-right-color: #FFFEB5;
    }
   `}
`;
//# sourceMappingURL=styles.js.map